export default function getResource(label, vars = []) {
    const resources = {
        freeReturnsBannerPrefix: 'Free',
        freeReturnsBannerSuffix: ' 30 day returns in-store or online*',
        freeReturnsInfoAriaLabel: 'Return policy details',

        freeShippingCardTitle: 'Free Shipping',
        fastDelivery: 'Fast Delivery',
        sameDayDelivery: 'Same-Day Delivery',
        pickupCardTitle: 'Pickup',

        pickupCardEta: 'As soon as today',
        fastDeliveryCardEta: 'As soon as today',

        asSoonAsToday: 'As soon as today',
        asSoonAsTomorrow: 'As soon as tomorrow',
        asSoonAs: `As soon as ${vars[0]}`,

        availableInAllStoresCardTitle: 'Available in All Stores',
        onlineOnly: 'Online Only',
        fastDeliveryNotAvailable: 'Not available for this item',
        fastDeliveryTemporarilyUnavailable: 'Temporarily unavailable',
        pickupNotAvailable: 'Not available for pickup',

        for: 'for',
        in: 'in',
        yourLocation: 'your location',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        limitedStock: 'Limited Stock',
        selectForStoreAvailability: 'Select to see availability',
        notAvailable: 'Not available',
        fastDeliveryNotAvailableForZip: 'Fast Delivery not available',
        fastDeliveryPanelZipAriaLabel: `${vars[0]}, change delivery location`,
        fastDeliveryPanelInfoAriaLabel: 'About Fast Delivery',

        sddRougeTestV2Message: `As a Rouge member, you're only ${vars[0]} away from FREE Same-Day Delivery.`,
        sddRougeTestV2FreeShippingMessage: 'As a Rouge member, you\'re getting FREE Same-Day Delivery.',
        fastDeliveryRougeTestV2Message: `As a Rouge member, you're only ${vars[0]} away from FREE Fast Delivery.`,
        fastDeliveryRougeTestV2FreeShippingMessage: 'As a Rouge member, you\'re getting FREE Fast Delivery.',

        shippingPanelTo: 'to',
        shippingPanelZipAriaLabel: 'Change delivery location',
        shippingPanelInfoAriaLabel: 'Shipping and return policy details',
        shippingPanelBiPrefix: 'Beauty Insiders enjoy ',
        shippingPanelBiSuffix: 'FREE standard shipping',
        freeStandardShipping: 'Free standard shipping',

        // Pickup details panel (SHP-5238)
        storesNearYou: 'stores near you',
        pickupPanelAt: 'at',
        pickupPanelChangeStoreAriaLabel: `${vars[0]}, change pickup store`,
        pickupPanelInfoAriaLabel: 'Buy Online & Pick Up details',
        inStorePickup: 'In-store pickup',
        curbsidePickup: 'Curbside pickup',
        curbsideConcierge: 'Curbside concierge',

        // Signed-out state (SHP-5258)
        signInLinkLabel: 'Sign in',
        createAccountLinkLabel: 'create an account',
        freeShippingSignInCardText: `${vars[0]} for`,
        freeShippingSignInAriaLabel: `${vars[0]} for ${vars[1]}`,
        shippingPanelSignInPrompt: `${vars[0]} or ${vars[1]} to enjoy ${vars[2]}`,

        // Nearby store availability row (SHP-5280)
        nearbyStores: 'nearby stores',
        nearbyStoresLinkAriaLabel: 'Check availability at nearby stores',

        // Auto-Replenish row
        autoReplenishRowSavePercent: `Save ${vars[0]}`,
        autoReplenishRowSuffix: ' with Auto-Replenish',
        autoReplenishRowCheckboxAriaLabel: `Save ${vars[0]} with Auto-Replenish`,

        autoReplenishRowSavePercentHotDeal: `Save ${vars[0]}*`,
        autoReplenishRowSuffixHotDeal: ' with Auto-Replenish Hot Deal',
        autoReplenishRowCheckboxAriaLabelHotDeal: `Save ${vars[0]} with Auto-Replenish Hot Deal`,

        deliveryEvery: 'Deliver every:',
        mostCommon: 'most common',
        deliveryFrequencyLinkAriaLabel: 'Change Auto-Replenish delivery frequency',
        autoReplenishRowNotEligible: 'Not eligible for Auto-Replenish',
        autoReplenishLegalOptIn: 'By enrolling, you consent to the reoccurring charge for your subscription.',
        learnMore: 'Learn more',
        autoReplenishFirstTimeLegalShown: `*First-time subscribers get ${vars[0]} off their first ${vars[1]} orders, delivered within ${vars[2]} months of the initial order placement. Promo period ends ${vars[3]}.`,
        autoReplenishFirstTimeLegalDetails: 'Details',
        autoReplenishFirstTimeLegalMoreDetails: `For each Hot Deal item, subscription and quantity is limited to 1 per customer. After ${vars[0]} replenishment orders at ${vars[1]} off or after ${vars[2]} months of the initial sign-up date, whichever comes first, the subscription renews at ${vars[3]} off.`,

        fulfillmentMethodsGroupAriaLabel: 'Choose a fulfillment method',
        outOfStockAt: `Out of Stock at ${vars[0]}`,
        outOfStockForZip: `Out of Stock for ${vars[0]}`,
        notAvailableInZip: `Not available in ${vars[0]}`,
        checkOtherStores: 'Check other stores',
        checkAnotherLocation: 'Check another location',

        checkNearbyStores: 'Check nearby stores',
        pickupNotOfferedAtStore: 'Pickup not offered at this store',
        pickupNotOfferedForItem: 'Pickup not offered for this item'
    };

    return resources[label];
}
